export type ProtectionType = 'DYNAMIC_DEFENSE' | 'DNS_PROTECTION';

export type UiTexts = {
    featureName: string;
    deactivationBody: string;
    reactivationBody: string;
    analyticsDeactivationLocation: string;
    analyticsReactivationLocation: string;
};

const DRAFT_NOTE = 'Any draft policy will be deleted.';

const UI_TEXTS_BY_PROTECTION_TYPE: Record<ProtectionType, UiTexts> = {
    DNS_PROTECTION: {
        featureName: 'DNS Protection',
        deactivationBody: 'Your network will no longer be protected from unsafe and malicious websites.',
        reactivationBody: 'Your network will resume protection from unsafe and malicious websites.',
        analyticsDeactivationLocation: 'dnsDeactivationModal',
        analyticsReactivationLocation: 'dnsActivationModal',
    },
    DYNAMIC_DEFENSE: {
        featureName: 'Dynamic Defense',
        deactivationBody: `Deactivate Dynamic Defense will allow all traffic on both directions and disable all protections. ${DRAFT_NOTE} Are you sure?`,
        reactivationBody: `Reactivate Dynamic Defense will restore the protection of the previous policy. ${DRAFT_NOTE}`,
        analyticsDeactivationLocation: 'deactivationModal',
        analyticsReactivationLocation: 'reactivationModal',
    },
};

export function getUiTextsByProtectionType(type: ProtectionType): UiTexts {
    return UI_TEXTS_BY_PROTECTION_TYPE[type];
}
